<nb-card class="card-box">
    <nb-card-header class="content-header">
        <nb-icon *ngIf="icon" class="icon" icon="{{icon}}" status="basic"></nb-icon>
        <span [ngClass]="{'title-without-icon' : !icon}" class="title">{{title | translate}}</span>
        <nb-icon icon="question-mark-circle-outline" nbTooltipStatus="control" class="me-2 cursor-help"
                 nbTooltip="{{getTooltipContent() | translate}}" nbTooltipPlacement="left"></nb-icon>
        <nb-icon class="close" icon="close-outline" (click)="cancel()"></nb-icon>
    </nb-card-header>
    <nb-card-body class="content-body">
        <ng-container *ngIf="isActive; else tryLater">
            <div *ngIf="currentCount >= totalCount" class="devices-slots-included-in-plan-box">
                <app-resource-information title="{{ (resource === resourceTypes['devices'] ? 'stats-and-resources.no-devices-slots-free' : resource === resourceTypes['transfer'] ? 'stats-and-resources.no-transfer-available' : 'stats-and-resources.no-users-slots-free') | translate}}"
                                          description="{{getDescriptionContent()}}"
                                          [chartData]="chartData"
                                          [doughnutDescription]="currentCount + '/' + totalCount"
                                          [doughnutHeight]="110"
                                          [doughnutWidth]="110">
                </app-resource-information>
            </div>
            <div class="main-content-box">
                <div class="included-your-plan-box">
                    <span class="name">
                        {{'stats-and-resources.included-in-your-plan' | translate}}
                        <span class="name--hint">({{'stats-and-resources.used' | translate}}/{{'stats-and-resources.total' | translate}})</span>
                    </span>
                    <span>{{currentCount}}<span *ngIf="resource === resourceTypes['transfer']" class="gigabyte">GB</span>/</span>
                    <span class="font-weight-700">{{totalCount}}<span *ngIf="resource === resourceTypes['transfer']" class="gigabyte">GB</span></span>
                </div>
                <div class="add-on-box">
                    <span class="name">{{'stats-and-resources.add-on' | translate}}</span>
                    <span class="font-weight-700">{{additionalResources}}<span *ngIf="resource === resourceTypes['transfer']" class="gigabyte">GB</span></span>
                </div>
                <div class="progressbar-box">
                    <app-range-slider [initialValue]="additionalResources" [minValue]="0" [maxValue]="totalLimit" (changedInput)="onChangeRangeValue($event)"></app-range-slider>
                </div>
                <div class="total-limit-box">
                    <span class="name font-weight-700">{{'stats-and-resources.total-limit' | translate}}</span>
                    <span class="font-weight-700">{{totalLimit}}<span *ngIf="resource === resourceTypes['transfer']" class="gigabyte">GB</span></span>
                </div>
                <div class="renew-every-month-box">
                    <span>{{'stats-and-resources.renew-every-month' | translate}}</span>
                </div>
                <div class="add-on-price-box">
                    <span class="font-weight-700">{{'stats-and-resources.add-on-price' | translate:{'price':price, 'currency':currency} }}</span>
                </div>
            </div>
            <div class="warning-information-box">
                <div>
                    <nb-icon icon="alert-circle-outline" status="basic"></nb-icon>
                </div>
                <p class="warning-information-box__text">
                    {{'stats-and-resources.final-bill-may-be-changed' | translate}}
                </p>
            </div>
            <div class="additional-information-box">
                <p class="additional-information-box__header font-weight-700">
                    {{'stats-and-resources.whats-next' | translate}}
                </p>
                <p class="additional-information-box__text">
                    {{'stats-and-resources.whats-next-content' | translate}}
                </p>
            </div>
        </ng-container>
        <ng-template #tryLater>
            <p class="try-again-later-box">{{'stats-and-resources.there-was-problem-with-settling-previous-purchase' | translate}}</p>
        </ng-template>
    </nb-card-body>
    <nb-card-footer class="content-footer" [ngClass]="{'try-again' : !isActive}">
        <ng-container *ngIf="isActive; else okButton">
            <button nbButton [size]="'large'" [status]="'control'" [appearance]="'outline'" (click)="cancel()" tabindex="-1">
                {{'common.cancel' | translate}}
            </button>
            <button nbButton [status]="'primary'" [size]="'large'" tabindex="-1" (click)="payNow()" [disabled]="additionalResources < 1">
                {{'stats-and-resources.pay-now' | translate}}
            </button>
        </ng-container>
        <ng-template #okButton>
            <button nbButton [size]="'large'" [status]="'control'" [appearance]="'outline'" (click)="cancel()" tabindex="-1">
                {{'common.ok' | translate}}
            </button>
        </ng-template>
    </nb-card-footer>
</nb-card>